import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SyncIosNativeSupportResponseDTO, SyncIosNativeSupportRqDTO } from './ios-native-support-sync.model';
import { Observable } from 'rxjs';
import { MultipartHttpRequestService } from '../../../../../../../common/services/multipart.http.request.service';

@Injectable({
  providedIn: 'root',
})
export class IosNativeSupportSyncService {
  constructor(
    private httpClient: HttpClient,
    private multipartHttpRequestService: MultipartHttpRequestService
  ) {}

  checkIosNativeSupportBatchFile(form: any): Observable<SyncIosNativeSupportResponseDTO> {
    return this.multipartHttpRequestService.sendMultipartHttpRequest<SyncIosNativeSupportResponseDTO>(
      '/game-def/sync-ios-support-check',
      'POST',
      form
    );
  }

  makeIosNativeBatchUpdate(rq: SyncIosNativeSupportRqDTO): Observable<void> {
    return this.httpClient.post<void>('/game-def/sync-ios-support', rq);
  }
}
